"use client";

import { cn } from "@/lib/utils";
import Image, { type ImageProps } from "next/image";
import { useState } from "react";
import { Skeleton } from "./skeleton";

type ImageWithSkeletonProps = Omit<ImageProps, "onLoad"> & {
  /**
   * Optional className for the skeleton element
   */
  skeletonClassName?: string;
};

/**
 * Image component that shows a shimmer skeleton while loading.
 * Wraps Next.js Image with loading state management.
 */
export function ImageWithSkeleton({
  className,
  skeletonClassName,
  alt,
  ...props
}: ImageWithSkeletonProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <>
      {/* Skeleton shown while image loads */}
      {!isLoaded && (
        <Skeleton
          className={cn("absolute inset-0 rounded-sm", skeletonClassName)}
        />
      )}
      <Image
        {...props}
        alt={alt}
        className={cn(
          className,
          "transition-opacity duration-300",
          isLoaded ? "opacity-100" : "opacity-0",
        )}
        onLoad={() => setIsLoaded(true)}
      />
    </>
  );
}
